export default {
  "root": "_root_8ylxn_1",
  "--reversed": "_--reversed_8ylxn_1",
  "input": "_input_8ylxn_1",
  "area": "_area_8ylxn_1",
  "thumb": "_thumb_8ylxn_1",
  "hitbox": "_hitbox_8ylxn_1",
  "--size-small": "_--size-small_8ylxn_1",
  "--size-medium": "_--size-medium_8ylxn_1",
  "--size-large": "_--size-large_8ylxn_1",
  "--size-small--m": "_--size-small--m_8ylxn_1",
  "--size-medium--m": "_--size-medium--m_8ylxn_1",
  "--size-large--m": "_--size-large--m_8ylxn_1",
  "--size-small--l": "_--size-small--l_8ylxn_1",
  "--size-medium--l": "_--size-medium--l_8ylxn_1",
  "--size-large--l": "_--size-large--l_8ylxn_1",
  "--size-small--xl": "_--size-small--xl_8ylxn_1",
  "--size-medium--xl": "_--size-medium--xl_8ylxn_1",
  "--size-large--xl": "_--size-large--xl_8ylxn_1"
};import "ni:sha-256;UolS3lluQcoouEMKTUKJEBDfcswfa_ihYsi3sPF74bk";